import { useState } from 'react'

import { DateLocationCell } from '~/app/pages/SurgeonScheduler/TablesLayout/shared'
import { getOnlyDate } from '~/astra'
import { createLocationSchedule, updateLocationSchedule } from '~/store/di-entity.api'
import { LocationSchedule, useLocationSchedule } from '~/storm'
import { getNonEmptyString } from '~/utils/utils'

type Props = { location: DateLocationCell }

const upsertNote = (selectedCell: DateLocationCell, locationSchedule?: LocationSchedule | null, newComment?: string) => {
    if (locationSchedule) {
        if (locationSchedule.comment === newComment) return

        return updateLocationSchedule(locationSchedule.id, {
            comment: newComment,
            location_id: selectedCell.locationId,
            scheduled_date: locationSchedule.scheduled_date,
        })
    }
    return createLocationSchedule({
        comment: newComment,
        location_id: selectedCell.locationId,
        scheduled_date: getOnlyDate(selectedCell.date),
    })
}

export const useLocationNotes = ({ location }: Props) => {
    const locationSchedule = useLocationSchedule({
        where: { scheduled_date: getOnlyDate(location.date), location_id: location.locationId },
    })
    const [note, setNote] = useState(locationSchedule?.comment ?? '')
    const lastUpdatedAt = locationSchedule?.updated_at
    const lastUpdatedBy = locationSchedule?.updated_by

    const [isLoading, setIsLoading] = useState(false)

    // provides and override to allow explicit saving
    const updateNote = async (noteToSave?: string) => {
        const newNote = getNonEmptyString(noteToSave ?? note)

        setIsLoading(true)

        try {
            await upsertNote(location, locationSchedule, newNote)
            setNote(newNote ?? '')
            setIsLoading(false)
        } catch (error) {
            console.error(error)
            setIsLoading(false)
            return
        }
    }

    const deleteNote = async () => {
        if (!locationSchedule) return
        const prompt = window.confirm('Er du sikker på at du vil fjerne notatet?')

        if (!prompt) return
        setIsLoading(true)

        try {
            setNote('')

            await updateLocationSchedule(locationSchedule.id, {
                ...locationSchedule,
                comment: undefined,
            })
            setIsLoading(false)
        } catch (error) {
            console.error(error)
            setIsLoading(false)
            return
        }
    }

    return {
        isLoading,
        updateNote,
        deleteNote,
        note,
        setNote,
        lastUpdatedAt,
        lastUpdatedBy,
    }
}
